<template>
  <textarea
    v-if="inlineEditMode && edit != null"
    v-model="edit"
    class="multi-line-text-field-fi--edit"
    rows="3"
  />
  <!-- eslint-disable vue/no-v-html -->
  <span
    v-else-if="html !== null"
    class="multi-line-text-field-fi"
    v-html="html"
  />
  <!-- eslint-enable vue/no-v-html -->
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue';

import { useInlineEdit } from '@/composables/inlineEdit';

defineOptions({
  name: 'MultiLineTextFieldFi',
});

const props = withDefaults(
  defineProps<{
    fallback?: string;
    fieldName?: string | null | undefined;
  }>(),
  {
    fallback: '',
    fieldName: undefined,
  },
);

const { inlineEditMode, fieldValue, offerEditMode, notifyChanges } = useInlineEdit(props.fieldName);

const html = computed(() => {
  if (fieldValue.value) {
    return fieldValue.value.editable || fieldValue.value.value;
  }
  if (props.fallback !== null && props.fallback !== undefined) {
    return props.fallback;
  }
  return null;
});

const edit = ref<string | null>(null);

watch(
  () => edit.value,
  (newValue: string | null) => notifyChanges(newValue !== fieldValue.value?.value, newValue),
);

onMounted(() => {
  if (!fieldValue.value || fieldValue.value.editable || !offerEditMode.value) {
    return;
  }
  edit.value = fieldValue.value.value ?? null;
});
</script>

<style scoped src="./multi-line-text-field-fi.scss" />
